/** @format */

import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "../../css/NavbarMobile.css";

/////////////   Redux  //////////////
import { saveLanguageWeb } from "../store/LanguageSlice";
import { useSelector, useDispatch } from "react-redux";

import Logo_Traffy from "../../assets/Logo_Traffy.png";
import Fondue_App_Icon from "../../assets/Fondue_App_Icon.png";

export default function NavbarMobileNew(props) {
  const { openBurger, type } = props;
  const globalData = useSelector((state) => ({ ...state }));
  const detailReport = JSON.parse(sessionStorage.getItem("detailReport2"));
  const [hasChecked, setHasChecked] = useState(false);
  const dispatch = useDispatch();

  const [isDropdownOpen, setDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  useEffect(() => {
    if (props.ticketNav) {
      console.log(props.ticketNav);
    }
  }, [props.ticketNav]);

  // useEffect(() => {
  //   // ฟังก์ชันสำหรับการโหลด Google Translate script
  //   const loadGoogleTranslate = () => {
  //     const script = document.createElement("script");
  //     script.src =
  //       "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
  //     document.head.appendChild(script);
  //     console.log("Google Translate script loaded.");
  //   };

  //   // ฟังก์ชันสำหรับ init การแปล
  //   const googleTranslateElementInit = () => {
  //     new window.google.translate.TranslateElement(
  //       {
  //         pageLanguage: "th", // ภาษาเริ่มต้น
  //         includedLanguages: "en,th", // ภาษาให้แปล
  //         layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
  //         autoDisplay: false,
  //       },
  //       "google_translate_element"
  //     );

  //     setTimeout(() => {
  //       const selectElem = document.querySelector(".goog-te-combo");
  //       if (selectElem) {
  //         selectElem.value = "en"; // แปลเป็นภาษาอังกฤษ
  //         selectElem.dispatchEvent(new Event("change"));
  //         console.log("Google Translate initialized and set to English.");
  //       }
  //     }, 1000); // หน่วงเวลา 1 วินาที
  //   };

  //   // ฟังก์ชันสำหรับการลบ Google Translate script
  //   const removeGoogleTranslate = () => {
  //     const script = document.querySelector(
  //       'script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]'
  //     );
  //     if (script) {
  //       script.remove();
  //       console.log("Google Translate script removed.");
  //     }
  //     const googleTranslateElement = document.getElementById(
  //       "google_translate_element"
  //     );
  //     if (googleTranslateElement) {
  //       googleTranslateElement.innerHTML = "";
  //       console.log("Google Translate element cleared.");
  //     }

  //     // ลบคลาสที่ Google Translate เพิ่มเข้ามาใน DOM
  //     document
  //       .querySelectorAll("[class^='goog-te']")
  //       .forEach((el) => el.remove());

  //     // ลบ style หรือคลาสอื่นๆ ที่ Google Translate อาจจะเพิ่มมา
  //     document.body.classList.remove("translated-ltr", "translated-rtl");
  //     document.querySelectorAll("[style]").forEach((el) => {
  //       if (el.style.cssText.includes("translate")) {
  //         el.style.cssText = ""; // ลบ style ที่เกี่ยวข้องกับการแปล
  //       }
  //     });
  //   };

  //   // ตรวจสอบสถานะ toggle_language
  //   if (globalData.language.toggle_language === false) {
  //     loadGoogleTranslate(); // ถ้า toggle_language เป็น false ให้เปิดการแปล
  //     window.googleTranslateElementInit = googleTranslateElementInit;
  //     console.log("Google Translate is enabled.");
  //   } else {
  //     removeGoogleTranslate(); // ถ้า toggle_language เป็น true ให้ปิดการแปล
  //     console.log("Google Translate is disabled.");
  //   }

  //   // ล้างเมื่อ component ถูก unmount
  //   return () => {
  //     removeGoogleTranslate();
  //   };
  // }, [globalData.language.toggle_language]);

  useEffect(() => {
    // console.log(detailReport);
  }, [detailReport]);

  const changeLang = (bool) => {
    setDropdownOpen(!isDropdownOpen);
    // dispatch(saveLanguageWeb(!globalData.language.toggle_language));
    dispatch(saveLanguageWeb(bool));
  };

  function handleBack() {
    sessionStorage.removeItem("detailReport2");
    sessionStorage.removeItem("authorization");
    window.location.reload();
  }

  return (
    <nav className="nav-mobile">
      <div
        style={{
          display: "flex",
          gap: "0.2rem",
          position: "absolute",
          left: "1rem",
        }}>
        <img
          className="img-icon-nav"
          src="https://storage.googleapis.com/traffy_public_bucket/attachment/2022-06/b92a4bdb1a981eabe982463edb20b97530cfc25c.png"></img>
        <img className="img-icon-nav" src={Fondue_App_Icon}></img>
      </div>

      {detailReport && detailReport["case"]["ticket_id"] && (
        <div style={{ display: "flex" }}>
          <svg
            onClick={() => handleBack()}
            style={{ position: "absolute", left: "85" }}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14 18L8 12L14 6L15.4 7.4L10.8 12L15.4 16.6L14 18Z"
              fill="#1D1B20"
            />
          </svg>

          <p className="ticket-nav">{detailReport["case"]["ticket_id"]}</p>
        </div>
      )}

      <div className="toggle-lang" onClick={toggleDropdown}>
        <p>
          {globalData.language.toggle_language === false ? "English" : "ไทย"}
        </p>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 22C10.6333 22 9.34167 21.7375 8.125 21.2125C6.90833 20.6875 5.84583 19.9708 4.9375 19.0625C4.02917 18.1542 3.3125 17.0917 2.7875 15.875C2.2625 14.6583 2 13.3667 2 12C2 10.6167 2.2625 9.32083 2.7875 8.1125C3.3125 6.90417 4.02917 5.84583 4.9375 4.9375C5.84583 4.02917 6.90833 3.3125 8.125 2.7875C9.34167 2.2625 10.6333 2 12 2C13.3833 2 14.6792 2.2625 15.8875 2.7875C17.0958 3.3125 18.1542 4.02917 19.0625 4.9375C19.9708 5.84583 20.6875 6.90417 21.2125 8.1125C21.7375 9.32083 22 10.6167 22 12C22 13.3667 21.7375 14.6583 21.2125 15.875C20.6875 17.0917 19.9708 18.1542 19.0625 19.0625C18.1542 19.9708 17.0958 20.6875 15.8875 21.2125C14.6792 21.7375 13.3833 22 12 22ZM12 19.95C12.4333 19.35 12.8083 18.725 13.125 18.075C13.4417 17.425 13.7 16.7333 13.9 16H10.1C10.3 16.7333 10.5583 17.425 10.875 18.075C11.1917 18.725 11.5667 19.35 12 19.95ZM9.4 19.55C9.1 19 8.8375 18.4292 8.6125 17.8375C8.3875 17.2458 8.2 16.6333 8.05 16H5.1C5.58333 16.8333 6.1875 17.5583 6.9125 18.175C7.6375 18.7917 8.46667 19.25 9.4 19.55ZM14.6 19.55C15.5333 19.25 16.3625 18.7917 17.0875 18.175C17.8125 17.5583 18.4167 16.8333 18.9 16H15.95C15.8 16.6333 15.6125 17.2458 15.3875 17.8375C15.1625 18.4292 14.9 19 14.6 19.55ZM4.25 14H7.65C7.6 13.6667 7.5625 13.3375 7.5375 13.0125C7.5125 12.6875 7.5 12.35 7.5 12C7.5 11.65 7.5125 11.3125 7.5375 10.9875C7.5625 10.6625 7.6 10.3333 7.65 10H4.25C4.16667 10.3333 4.10417 10.6625 4.0625 10.9875C4.02083 11.3125 4 11.65 4 12C4 12.35 4.02083 12.6875 4.0625 13.0125C4.10417 13.3375 4.16667 13.6667 4.25 14ZM9.65 14H14.35C14.4 13.6667 14.4375 13.3375 14.4625 13.0125C14.4875 12.6875 14.5 12.35 14.5 12C14.5 11.65 14.4875 11.3125 14.4625 10.9875C14.4375 10.6625 14.4 10.3333 14.35 10H9.65C9.6 10.3333 9.5625 10.6625 9.5375 10.9875C9.5125 11.3125 9.5 11.65 9.5 12C9.5 12.35 9.5125 12.6875 9.5375 13.0125C9.5625 13.3375 9.6 13.6667 9.65 14ZM16.35 14H19.75C19.8333 13.6667 19.8958 13.3375 19.9375 13.0125C19.9792 12.6875 20 12.35 20 12C20 11.65 19.9792 11.3125 19.9375 10.9875C19.8958 10.6625 19.8333 10.3333 19.75 10H16.35C16.4 10.3333 16.4375 10.6625 16.4625 10.9875C16.4875 11.3125 16.5 11.65 16.5 12C16.5 12.35 16.4875 12.6875 16.4625 13.0125C16.4375 13.3375 16.4 13.6667 16.35 14ZM15.95 8H18.9C18.4167 7.16667 17.8125 6.44167 17.0875 5.825C16.3625 5.20833 15.5333 4.75 14.6 4.45C14.9 5 15.1625 5.57083 15.3875 6.1625C15.6125 6.75417 15.8 7.36667 15.95 8ZM10.1 8H13.9C13.7 7.26667 13.4417 6.575 13.125 5.925C12.8083 5.275 12.4333 4.65 12 4.05C11.5667 4.65 11.1917 5.275 10.875 5.925C10.5583 6.575 10.3 7.26667 10.1 8ZM5.1 8H8.05C8.2 7.36667 8.3875 6.75417 8.6125 6.1625C8.8375 5.57083 9.1 5 9.4 4.45C8.46667 4.75 7.6375 5.20833 6.9125 5.825C6.1875 6.44167 5.58333 7.16667 5.1 8Z"
            fill="#1D1B20"
          />
        </svg>
      </div>

      {isDropdownOpen && (
        <div className="dropdown-menu">
          <p onClick={() => changeLang(false)}>English</p>
          <p onClick={() => changeLang(true)}>ไทย</p>
        </div>
      )}
    </nav>
  );
}
